import { cn } from "@/lib/utils";
import { Button } from "./Button";

/**
 * The one segmented control (native `Picker(.segmented)`): a sidebar-tinted
 * track with the chosen segment raised on the canvas colour. Used by Settings
 * (appearance, typography) and the inspector tabs.
 */
export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  fill = false,
  className,
}: {
  options: readonly { value: T; label: string }[];
  value: T;
  onChange: (v: T) => void;
  /** Stretch to the container, segments equal width. */
  fill?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "gap-0.5 rounded-full bg-sidebar p-0.5 font-chrome",
        fill ? "flex w-full" : "inline-flex w-fit",
        className,
      )}
    >
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <Button
            key={opt.value}
            variant="ghost"
            aria-pressed={active}
            onClick={() => onChange(opt.value)}
            className={cn(
              "h-7 border-0 px-3 text-[13px] font-normal",
              fill && "flex-1",
              active
                ? "bg-canvas font-medium text-ink shadow-sm hover:bg-canvas active:bg-canvas"
                : "text-ink-secondary hover:bg-transparent hover:text-ink active:bg-transparent",
            )}
          >
            {opt.label}
          </Button>
        );
      })}
    </div>
  );
}
